"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _Stepper = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/form/Stepper"));
var _Modal = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/Modal"));
var _ModalHeader = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/layout/ModalHeader"));
var _Body = _interopRequireDefault(require("@oberoninternal/travelbase-ds/components/primitive/Body"));
var _useSesame = _interopRequireDefault(require("@oberoninternal/travelbase-ds/hooks/useSesame"));
var _grid = require("@rebass/grid");
var _lodash = _interopRequireDefault(require("lodash.isequal"));
var _react = _interopRequireWildcard(require("react"));
var _reactIntl = require("react-intl");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _customizationClassNames = require("../constants/customizationClassNames");
var _travelGroupMessages = _interopRequireDefault(require("../constants/travelGroupMessages"));
var _TenantContext = require("../context/TenantContext");
var _usePrevious = _interopRequireDefault(require("../hooks/usePrevious"));
var _getTripGroupText = _interopRequireDefault(require("../utils/getTripGroupText"));
var _Dropdown = _interopRequireWildcard(require("./designsystem/Dropdown"));
var _Persons = _interopRequireDefault(require("./svg/Persons.svg"));
const _excluded = ["loading", "booking", "setBooking", "dropDownBorderRadius", "maxOccupancy", "minOccupancy", "maxExtraBabyOccupancy", "petsAllowed", "variant", "surfaceElementVariant"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var __jsx = _react.default.createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
const createGetGroupTypeProps = intl => type => {
  const {
    label,
    name,
    description
  } = _travelGroupMessages.default[type];
  return {
    name,
    label: intl.formatMessage(label),
    description: description && intl.formatMessage(description)
  };
};
const TripGroupInput = /*#__PURE__*/(0, _react.memo)(_ref => {
  let {
      loading,
      booking,
      setBooking,
      dropDownBorderRadius,
      maxOccupancy,
      minOccupancy,
      maxExtraBabyOccupancy,
      petsAllowed,
      variant = 'dropdown',
      surfaceElementVariant = 'input'
    } = _ref,
    props = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  const sesame = (0, _useSesame.default)(false, {
    closeOnClickOutside: true,
    closeOnEscape: true
  });
  const onToggle = props.onToggle ?? sesame.onToggle;
  const open = props.open ?? sesame.open;
  const intl = (0, _reactIntl.useIntl)();
  const getGroupTypeProps = createGetGroupTypeProps(intl);
  const {
    brandConfig
  } = (0, _TenantContext.useTenantContext)();
  const {
    0: localBooking,
    1: setLocalBooking
  } = (0, _react.useState)(booking);
  const prevOpen = (0, _usePrevious.default)(open);
  const prevBooking = (0, _usePrevious.default)(booking);
  const numberOfPersons = (localBooking.amountAdults ?? 0) + (localBooking.amountYouths ?? 0) + (localBooking.amountChildren ?? 0);
  const getMaximum = (tripGroupPersons = 0) => {
    if (maxOccupancy && numberOfPersons) {
      return maxOccupancy - numberOfPersons + tripGroupPersons;
    }
    return 120;
  };
  const getMinimum = (tripGroupPersons = 0, defaultMin = 0) => {
    if (numberOfPersons === 1) {
      return 1;
    }
    if (numberOfPersons === minOccupancy) {
      return tripGroupPersons;
    }
    return defaultMin;
  };
  (0, _react.useEffect)(() => {
    if (!(0, _lodash.default)(prevBooking, booking)) {
      setLocalBooking(booking);
    }
  }, [booking, prevBooking]);
  (0, _react.useEffect)(() => {
    if (variant === 'modal' || variant === 'dropdown') {
      if (prevOpen && !open && !(0, _lodash.default)(localBooking, booking)) {
        setBooking(localBooking);
      }
      if (!prevOpen && open && !(0, _lodash.default)(localBooking, booking)) {
        setLocalBooking(booking);
      }
    }
    if (variant === 'inputs') {
      if (!(0, _lodash.default)(localBooking, booking)) {
        setBooking(localBooking);
      }
    }
  }, [booking, localBooking, open, prevOpen, setBooking, variant]);
  const common = (0, _react.useMemo)(() => ({
    loading,
    setBooking: setLocalBooking,
    booking: localBooking,
    editable: true
  }), [loading, localBooking]);
  const renderInputFields = () => brandConfig.groupTypes.map(type => {
    const rowProps = _objectSpread(_objectSpread(_objectSpread({}, common), getGroupTypeProps(type)), {}, {
      onToggle,
      open
    });
    switch (type) {
      case 'adults':
        return __jsx(Row, (0, _extends2.default)({
          minimum: getMinimum(localBooking.amountAdults),
          maximum: getMaximum(localBooking.amountAdults),
          key: type,
          dataCy: "tripGroupAdults"
        }, rowProps));
      case 'babies':
        return __jsx(Row, (0, _extends2.default)({
          minimum: 0,
          maximum: maxExtraBabyOccupancy,
          key: type,
          dataCy: "tripGroupBabies"
        }, rowProps));
      case 'children':
        return __jsx(Row, (0, _extends2.default)({
          minimum: getMinimum(localBooking.amountChildren),
          maximum: getMaximum(localBooking.amountChildren),
          key: type,
          dataCy: "tripGroupChildren"
        }, rowProps));
      case 'pets':
        return __jsx(Row, {
          maximum: petsAllowed,
          petsAllowed: petsAllowed,
          description: petsAllowed === 0 && __jsx(_reactIntl.FormattedMessage, {
            id: "diBJre",
            defaultMessage: [{
              "type": 0,
              "value": "Niet toegestaan"
            }]
          }),
          key: type,
          name: rowProps.name,
          label: rowProps.label,
          booking: rowProps.booking,
          setBooking: rowProps.setBooking,
          loading: rowProps.loading,
          dataCy: "tripGroupPets"
        });
      case 'youth':
        return __jsx(Row, (0, _extends2.default)({
          minimum: getMinimum(localBooking.amountYouths),
          maximum: getMaximum(localBooking.amountYouths),
          key: type,
          dataCy: "tripGroupYouth"
        }, rowProps));
      default:
        throw new Error('Invalid grouptype defined in brandConfig.');
    }
  });
  const guestsText = (0, _getTripGroupText.default)(intl, localBooking);
  return variant === 'dropdown' ? __jsx(_Dropdown.default, {
    ref: sesame.ref,
    width: props.width,
    className: props.className,
    title: guestsText,
    surfaceElement: surfaceElementVariant === 'searchbar' ? __jsx(_react.default.Fragment, null, __jsx(_grid.Flex, {
      flexWrap: "wrap"
    }, __jsx(_grid.Box, {
      width: 1
    }, __jsx(StyledBody, {
      variant: "tiny"
    }, __jsx(_reactIntl.FormattedMessage, {
      id: "P0UVuU",
      defaultMessage: [{
        "type": 0,
        "value": "Reisgezelschap"
      }]
    }))), __jsx(_grid.Box, {
      width: 1
    }, __jsx(_grid.Box, null, __jsx(StyledDropdownDescription, {
      variant: "small",
      isPlaceholder: !guestsText
    }, guestsText || __jsx(_reactIntl.FormattedMessage, {
      id: "P0UVuU",
      defaultMessage: [{
        "type": 0,
        "value": "Reisgezelschap"
      }]
    })))))) : __jsx(_react.default.Fragment, null, __jsx(StyledPersons, {
      className: "gt-s",
      style: {
        marginRight: '1rem',
        marginTop: '-3px'
      }
    }), __jsx(StyledDropdownDescription, {
      isPlaceholder: !guestsText
    }, guestsText || __jsx(_reactIntl.FormattedMessage, {
      id: "P0UVuU",
      defaultMessage: [{
        "type": 0,
        "value": "Reisgezelschap"
      }]
    }))),
    borderRadius: dropDownBorderRadius,
    open: open,
    onToggle: onToggle,
    dataCy: "tripGroupInput",
    scrollIntoView: true,
    modifiers: {
      flip: {
        enabled: false
      }
    }
  }, open && __jsx(_grid.Box, {
    p: 4,
    width: "32rem",
    style: {
      maxWidth: '100vw'
    }
  }, renderInputFields())) : variant === 'modal' ? __jsx(_react.default.Fragment, null, __jsx(_Dropdown.default, {
    width: props.width,
    className: props.className,
    title: guestsText,
    surfaceElement: __jsx(_react.default.Fragment, null, __jsx(StyledPersons, {
      className: "gt-s",
      style: {
        marginRight: '1rem',
        marginTop: '-3px'
      }
    }), __jsx(StyledDropdownDescription, {
      isPlaceholder: !guestsText
    }, guestsText || __jsx(_reactIntl.FormattedMessage, {
      id: "P0UVuU",
      defaultMessage: [{
        "type": 0,
        "value": "Reisgezelschap"
      }]
    }))),
    borderRadius: dropDownBorderRadius,
    open: open,
    onToggle: onToggle,
    dataCy: "tripGroupInput",
    scrollIntoView: true,
    modifiers: {
      flip: {
        enabled: false
      }
    }
  }), __jsx(_Modal.default, {
    variant: "small",
    open: open,
    onClose: onToggle
  }, __jsx(_ModalHeader.default, null, __jsx(_reactIntl.FormattedMessage, {
    id: "P0UVuU",
    defaultMessage: [{
      "type": 0,
      "value": "Reisgezelschap"
    }]
  })), __jsx(_grid.Box, {
    p: 4
  }, renderInputFields()))) : __jsx(_react.default.Fragment, null, renderInputFields());
});
const Row = ({
  label,
  description,
  minimum = 0,
  maximum = 10,
  name,
  loading,
  booking,
  setBooking,
  petsAllowed,
  editable,
  dataCy
}) => {
  const setValue = val => {
    setBooking(_objectSpread(_objectSpread({}, booking), {}, {
      [name]: val
    }));
  };
  return __jsx(_grid.Flex, {
    justifyContent: "space-between",
    alignItems: "center",
    "data-cy": dataCy
  }, __jsx(_grid.Box, null, __jsx(_Body.default, {
    style: {
      textTransform: 'capitalize',
      fontWeight: 400
    }
  }, label), __jsx(Description, {
    variant: "small"
  }, description)), __jsx(_Stepper.default, {
    editable: !!editable,
    size: "medium",
    disabled: loading || name === 'amountPets' && petsAllowed === 0,
    variant: "outline",
    minimum: minimum,
    maximum: maximum,
    value: booking[name] ?? 0,
    setValue: value => {
      if (typeof value === 'number') {
        setValue(value);
      }
    },
    nullable: false,
    buttonClassName: _customizationClassNames.CLASS_SEARCH_BOX_TRIP_GROUP_FIELD_ROUND_BUTTON
  }));
};
const StyledBody = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "TripGroupInput__StyledBody",
  componentId: "sc-1wbfqg9-0"
})(["color:", ";font-weight:300 !important;text-align:start;line-height:1.15;"], ({
  theme
}) => theme.colors.neutral['60']);
const Description = (0, _styledComponents.default)(_Body.default).withConfig({
  displayName: "TripGroupInput__Description",
  componentId: "sc-1wbfqg9-1"
})([""]);
const StyledPersons = (0, _styledComponents.default)(_Persons.default).withConfig({
  displayName: "TripGroupInput__StyledPersons",
  componentId: "sc-1wbfqg9-2"
})(["color:", ";width:2rem;"], ({
  theme
}) => theme.colors.neutral['40']);
const StyledDropdownDescription = (0, _styledComponents.default)(_Dropdown.DropdownDescription).withConfig({
  displayName: "TripGroupInput__StyledDropdownDescription",
  componentId: "sc-1wbfqg9-3"
})(["", ";"], ({
  isPlaceholder,
  theme
}) => isPlaceholder && `color: ${theme.colors.neutral['60']}`);
var _default = exports.default = TripGroupInput;